import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { GlobalStyles } from '@/presentation/components/LightBox';
import { Lateral } from './LateralPDF';
import VisualModel from './VisualMode';

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  onClickButton?: () => void;
  pdf?: boolean;
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({
  isOpen,
  onClose,
  name,
  onClickButton,
  pdf
}) => {
  if (!isOpen) return null;

  return (
    <div data-testid="cmp-ModalWrapper">
      <GlobalStyles />
      <Lateral>
        <OutsideClickHandler onOutsideClick={onClose}>
          <VisualModel
            onClose={onClose}
            title={name}
            onClickButton={onClickButton}
            pdf={pdf}
          />
        </OutsideClickHandler>
      </Lateral>
    </div>
  );
};

export default ModalWrapper;
